import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify);


import es from 'vuetify/lib/locale/es'

Vue.component('my-component', {
  methods: {
    changeLocale () {
      this.$vuetify.lang.current = 'es'
    },
  },
})



export default new Vuetify({
  
  lang: {
    locales: { es },
    current: 'es',
  },

  theme: {
    dark: false,
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        primary: '#009688',
        secondary: '#424242',
        accent: '#2196f3',
        femm:'#f73378',
        error: '#FF5252',
        info: '#2196F3',
        success: '#00C851',
        warning: '#FFC107',
        icons:'#FFFFFF'
      },
    },
    
  },
  icons: {
    iconfont: 'md',
  },
});